<template>
  <label class="bbp-input-text">
    <input class="bbp-input" type="text"
           :class="{
             'bbp-input_error': error
           }"
           v-model="value"
           @input="setValue"
           :disabled="input.disabled"
           v-autofocus="!!input.autofocus"
           :placeholder="input.placeholder">
    <div class="bbp-input-text-number">
      <i class="bbp-icon-info bbp-input-text-number__icon"
         v-if="invoiceId && input.model === 'currentAmount' && (valueNumber < totalAmount)"
         @mouseenter="showInfo = true"
         @mouseleave="showInfo = false"
      />
      <transition name="bbp-bounce">
        <div class="bbp-input-text-number-popup" v-if="showInfo && popupText">
          {{popupText}}
        </div>
      </transition>
    </div>
    <transition name="fade">
      <span class="bbp-input-text__error bbp-error-text" v-if="error">{{error}}</span>
    </transition>
  </label>
</template>

<script>
import {get, set, round} from 'lodash'
import convertNumber from '@/mixin/convertNumber'
export default {
  name: 'BBPInputText',
  props: ['input', 'model', 'project', 'defaultModel', 'errorText'],
  mixins: [convertNumber],
  data () {
    return {
      value: '',
      valueNumber: 0,
      error: '',
      showInfo: false
    }
  },
  computed: {
    invoiceId () {
      return get(this.project, 'invoiceId', '')
    },
    popupText () {
      const prop = get(this.input, 'popup', '')
      const value = get(this.defaultModel, prop, 0)
      const convertValue = this.convertNumber(value)
      return `AED ${convertValue}`
    },
    totalAmount () {
      const prop = get(this.input, 'totalAmount', '')
      return get(this.defaultModel, prop, '')
    }
  },
  methods: {
    setValue () {
      const format = this.input.format
      let result = this.value
      this.error = false
      this.$emit('error', false)
      if (format === 'number') {
        result = this.validateNumber()
      }
      set(this.model, this.input.model, result)
      this.$emit('input', result)
    },
    validateNumber () {
      this.value = this.toNumSave(this.value)
      const result = this.toNumSave(this.value, true)
      if (isNaN(+result)) {
        this.$emit('error', 'enter the number')
        this.error = 'enter the number'
        return ''
      } else {
        this.$emit('error', false)
        this.error = ''
      }
      return round(+result, 2)
    },
    toNumSave (value, num) {
      const regexNum = /[0-9]+|\./gmi
      const regexInput = /[0-9]+|,+|\.+/gmi
      const regex = num ? regexNum : regexInput
      if (typeof value === 'string') {
        const match = value.match(regex) || []
        return match.join('')
      }
    },
    setDefaultVal () {
      const type = get(this.input, 'format', '')
      const value = get(this.model, this.input.model, '')
      if (!value) return
      if (type === 'number') {
        this.value = this.convertNumber(value)
        this.valueNumber = value
      } else {
        this.value = value
      }
    }
  },
  watch: {
    errorText () {
      this.error = this.errorText
    }
  },
  beforeMount () {
    this.setDefaultVal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-input-text {
    position: relative;
    display: flex;
    align-items: center;

    &-number {
      position: absolute;
      right: 10px;

      &__icon {
        color: $color-accent;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      &-popup {
        position: absolute;
        padding: 7px;
        right: 2px;
        top: 22px;
        white-space: nowrap;
        background: rgba($color-black, 0.55);
        border-radius: 5px;
        color: $color-white;
        user-select: none;
        pointer-events: none;
        max-width: 60vw;

        &:before {
          content: '';
          position: absolute;
          left: auto;
          top: -3px;
          right: 4px;
          display: block;
          width: 0;
          height: 0;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-bottom: 3px solid rgba($color-black, 0.55);
        }
      }
    }

    &__error {
      right: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPInputText/BBPInputText.vue